import {createReducer, on} from '@ngrx/store';
import * as locationAction from '@app/marketplace/locations/state/locations-actions';
import * as fromLocation from './locations-state'

const initialState: fromLocation.State = {isSuccess:true,locationType: fromLocation.LocationTypeEnum.Municipality, locations: []};
export const reducer = createReducer(
  initialState,
  /* on(locationAction.UpdatingLocation, (state) => {
    return {...state,isSuccess:false};
  }), */
  on(locationAction.UpdatedLocation, (state, {locationType,locations}) => {
    return {...state, locationType:locationType,locations:locations,isSuccess:true};
  }),
);

